import React from 'react';
import { Link } from 'react-router-dom';
import { Image } from './../../../components';
import { heights, widths, fonts } from './../../../styles/theme.json';

const BlogLink = (props) => {

  return (
    <li className={'blog_landing_item ' + props.data.layout_style}>
      <Link className="blog_landing_link" to={'/' + props.data.link.postType + '/' + props.data.link.slug}>
        <div className={'blog_image-wrapper'}>
          <Image source={props.data.image.large}/>
        </div>
        <div className={'blog_landing_caption_wrapper'}>
          <div className={'blog_landing_caption'}>
            <h2 className={'blog_caption_title medium-header'}>{props.data.link.title}</h2>
            <p className={'blog_caption_date'}>{props.data.date}</p>
          </div>
        </div>
      </Link>
    </li>
  );
};

export default BlogLink;




// WEBPACK FOOTER //
// ./src/pages/blog/blog_landing/BlogLink.js